import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Sketch from '../components/sketch'
import { log } from 'handlebars';


class Services extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      service: [],
      row: [],
      title: null,
      service1: null,
      service2: null,
      service3: null,
      spacer0: null,
      spacer1: null,
      spacer2: null,
      lines: null
    }

  }

  mount() {

    ScrollTrigger.create({
               trigger: this.ref.spacer0,
               start: "top top+=10%",
                id: "trigger4",
               onEnter: ({
                 progress,
                 direction,
                 isActive
               }) => {
                 this.ref.service1.classList.add("inview")
               },
               onLeaveBack: ({
                 progress,
                 direction,
                 isActive
               }) => {
                 this.ref.service1.classList.remove("inview")
               }
             });


      ScrollTrigger.create({
        trigger: this.ref.spacer1,
        start: "top top",
         id: "trigger5",
        onEnter: ({
          progress,
          direction,
          isActive
        }) => {
          this.ref.service2.classList.add("inview")
        },
        onLeaveBack: ({
          progress,
          direction,
          isActive
        }) => {
          this.ref.service2.classList.remove("inview")
        }
      });


      ScrollTrigger.create({
        trigger: this.ref.spacer2,
        start: "top top",
         id: "trigger6",
        onEnter: ({
          progress,
          direction,
          isActive
        }) => {
          this.ref.service3.classList.add("inview")
        },
        onLeaveBack: ({
          progress,
          direction,
          isActive
        }) => {
          this.ref.service3.classList.remove("inview")
        }
      });

   

    this.anim1 = gsap.to(this.ref.service1, {
      opacity: 0,
      scale: .9,
      duration: 1,
      scrollTrigger: {
        trigger: this.ref.spacer1,
        start: "top top+=50%", // the default values
        end: "top top",
        scrub: .5

      }
    });

     

    this.anim2 = gsap.to(this.ref.service2, {
      opacity: 0,
      scale: 1,
      duration: 1,
      scrollTrigger: {
        trigger: this.ref.spacer2,
        start: "top top+=50%", // the default values
        end: "top top",
        scrub: .5

      }
    });

    this.anim3 = gsap.fromTo(this.ref.lines, {
        yPercent: 100,
    }, {
      yPercent: 0,
      duration: 1,
      scrollTrigger: {
        trigger: this.ref.spacer0,
        start: "top top-=50%", // the default values
        end: "bottom top",
        scrub: .5

      }
    });
    

    _each(this.ref.row, (item)=> {

      $(item).on('click',(e)=> {
        $('.is-opened').not(item).removeClass('is-opened') 
        $(item).toggleClass('is-opened')
      }
      ) 
    })

    ScrollTrigger.create({
      trigger: this.ref.title,
      start: "top bottom",
       id: "trigger7",
      onEnter: ({
        progress,
        direction,
        isActive
      }) => {
        this.ref.title.classList.add("inview")
      },
      onLeaveBack: ({
        progress,
        direction,
        isActive
      }) => {
        this.ref.title.classList.remove("inview")
      }
    });

  


    
}






  unmount() {

    _each(this.ref.row, (item) => {

      $(item).off('click')
    })

    ScrollTrigger.getById("trigger4").kill();
    ScrollTrigger.getById("trigger5").kill();
    ScrollTrigger.getById("trigger6").kill();
    ScrollTrigger.getById("trigger7").kill();

    this.anim1.kill()
    this.anim2.kill()
    this.anim3.kill()



  }


}

module.exports = Services
